import { render } from "./SpinnerComp.vue?vue&type=template&id=0cb0fb6c&scoped=true"
import script from "./SpinnerComp.vue?vue&type=script&lang=js"
export * from "./SpinnerComp.vue?vue&type=script&lang=js"

import "./SpinnerComp.vue?vue&type=style&index=0&id=0cb0fb6c&scoped=true&lang=css"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb0fb6c"]])

export default __exports__